import type { AxiosError } from 'axios'
import axios from 'axios'

import environment from '@/environment'
import type { ControllerRestartMethod, ControllerRestartStatusResponse } from '@/features/controller/restart/types'
import type { ControllerDescription } from '@/features/controller/types'

export const BASE_DEVICE_MANAGEMENT_API_URL = `${environment.services.deviceManagerApiUrl}`

export const GET_CONTROLLER_BY_EQUIPMENT_NUMBER_API = 'GET_CONTROLLER_BY_EQUIPMENT_NUMBER'
export const GET_CONTROLLER_DESCRIPTION_API = 'GET_CONTROLLER_DESCRIPTION'
export const GET_CONTROLLER_RESTART_STATUS_API = 'GET_CONTROLLER_RESTART_STATUS'

export type getControllerOptions = {
  skipGlobalForbiddenErrorInterceptor?: boolean
}

export async function getControllerByEquipmentNumber(
  controllerEquipmentNumber: number,
  options?: getControllerOptions,
): Promise<ControllerDescription | null> {
  try {
    const response = await axios.get(
      `${BASE_DEVICE_MANAGEMENT_API_URL}/controllers/by-equipment-number/${controllerEquipmentNumber}`,
      {
        fetchOptions: { skipGlobalForbiddenErrorInterceptor: options?.skipGlobalForbiddenErrorInterceptor },
      },
    )
    return response.data
  } catch (e) {
    if ((e as AxiosError).status === 404) {
      return null
    }
    throw e
  }
}

export async function getControllerDescription(
  id: string,
  options?: getControllerOptions,
): Promise<ControllerDescription | null> {
  try {
    const response = await axios.get(`${BASE_DEVICE_MANAGEMENT_API_URL}/controllers/${id}`, {
      fetchOptions: { skipGlobalForbiddenErrorInterceptor: options?.skipGlobalForbiddenErrorInterceptor },
    })
    return response.data
  } catch (e) {
    if ((e as AxiosError).status === 404) {
      return null
    }
    throw e
  }
}

export async function restartController(controllerId: string, restartMethod: ControllerRestartMethod): Promise<void> {
  const response = await axios.post(
    `${BASE_DEVICE_MANAGEMENT_API_URL}/controllers/${controllerId}/restart?restartMethod=${restartMethod}`,
  )
  return response.data
}

export async function getControllerRestartStatus(controllerId: string): Promise<ControllerRestartStatusResponse> {
  const response = await axios.get(`${BASE_DEVICE_MANAGEMENT_API_URL}/controllers/${controllerId}/restart-status`)
  return response.data
}
